import type { MetricDisplayItem, PoolMetricsDataBase } from '@/types/poolMetrics/poolMetricsTypes'
import {
  DASHBOARD_COLORS,
  DASHBOARD_DEFAULTS,
  DASHBOARD_LABELS,
  DECIMAL_PLACES,
  FORMAT_TEMPLATES,
} from '@/constants/dashboard'
import { bigIntToNumber, formatUSD } from '~/utils/formatting'

export type { MetricDisplayItem, PoolMetricsDataBase } from '@/types/poolMetrics/poolMetricsTypes'

export function formatApyDisplay(baseApy: number): string {
  return baseApy ? `${baseApy.toFixed(DECIMAL_PLACES.APY_PERCENTAGE)}${FORMAT_TEMPLATES.PERCENTAGE_SUFFIX}` : FORMAT_TEMPLATES.FALLBACK_PERCENTAGE
}

export function formatUsdDisplay(amount: bigint, decimals: number = DECIMAL_PLACES.DEFAULT_TOKEN_DECIMALS): string {
  return formatUSD(bigIntToNumber(amount, decimals))
}

export function buildMetricDisplayItems(metrics: PoolMetricsDataBase): MetricDisplayItem[] {
  const {
    baseApy,
    assets,
    memberDeposits,
    sponsorDeposits,
    accruedRewards,
    stats,
  } = metrics

  return [
    {
      label: DASHBOARD_LABELS.VAULT_APY,
      value: formatApyDisplay(baseApy),
      color: DASHBOARD_COLORS.VAULT_APY,
    },
    {
      label: DASHBOARD_LABELS.TOTAL_DEPOSITS,
      value: formatUsdDisplay(assets),
      color: DASHBOARD_COLORS.TOTAL_DEPOSITS,
    },
    {
      label: DASHBOARD_LABELS.MEMBER_DEPOSITS,
      value: formatUsdDisplay(memberDeposits),
      color: DASHBOARD_COLORS.MEMBER_DEPOSITS,
    },
    {
      label: DASHBOARD_LABELS.SPONSOR_DEPOSITS,
      value: formatUsdDisplay(sponsorDeposits),
      color: DASHBOARD_COLORS.SPONSOR_DEPOSITS,
    },
    {
      label: DASHBOARD_LABELS.ACCRUED_REWARDS,
      value: formatUsdDisplay(accruedRewards),
      color: DASHBOARD_COLORS.ACCRUED_REWARDS,
    },
    {
      label: DASHBOARD_LABELS.TOTAL_MEMBERS,
      value: stats?.totalMembers ?? DASHBOARD_DEFAULTS.FALLBACK_COUNT,
      color: DASHBOARD_COLORS.TOTAL_MEMBERS,
    },
    {
      label: DASHBOARD_LABELS.BRONZE_TIER_MEMBERS,
      value: stats?.membersByTier?.bronze ?? DASHBOARD_DEFAULTS.FALLBACK_COUNT,
      color: DASHBOARD_COLORS.INSURANCE_TIERS,
    },
    {
      label: DASHBOARD_LABELS.SILVER_TIER_MEMBERS,
      value: stats?.membersByTier?.silver ?? DASHBOARD_DEFAULTS.FALLBACK_COUNT,
      color: DASHBOARD_COLORS.INSURANCE_TIERS,
    },
    {
      label: DASHBOARD_LABELS.GOLD_TIER_MEMBERS,
      value: stats?.membersByTier?.gold ?? DASHBOARD_DEFAULTS.FALLBACK_COUNT,
      color: DASHBOARD_COLORS.INSURANCE_TIERS,
    },
  ]
}
